export default __webpack_public_path__ + "static/rsz_thumbnail_-_do_małych_zdjęć_tomasz_pelczarski-7d944334d36d72a304d012afb0483abb.jpg";